/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import ProfessionalLearningIcon from 'icons/ProfessionalLearningIcon';

const messages = defineMessages({
  title: {id: 'navigation.professional-learning'},
});

const ProfessionalLearningItem = () => (
  <RouteLinkItem
    iconBefore={ProfessionalLearningIcon}
    route="midas/my/professional-learning"
    title={messages.title}
  />
);

export default ProfessionalLearningItem;
